import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_CENTRO_CUSTO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_FORNECEDOR,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_GRUPO,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS](state, selectedStatus) {
    state.selectedStatus = selectedStatus;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_CENTRO_CUSTO](state, centroCusto) {
    state.centroCusto = centroCusto;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_RESPONSAVEL](state, responsavel) {
    state.responsavel = responsavel;
  },
  [SET_FORNECEDOR](state, fornecedor) {
    state.fornecedor = fornecedor;
  },
  [SET_DATA_FINAL](state, dataFinal) {
    state.dataFinal = dataFinal;
  },
  [SET_DATA_INICIAL](state, dataInicial) {
    state.dataInicial = dataInicial;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
};
